// src/pages/ManageFacilities.jsx
import React, { useState, useRef, useEffect } from "react";
import MasterLayout from "../otherImages/MasterLayout";
import DefaultTopBar from "../components/DefaultTopBar";
import FacilityDataTable from "../components/FacilityDataTable";
import { useDispatch, useSelector } from "react-redux";
import {
  downloadFacilitiesCSV,
  clearFacilityState,
} from "../redux/slices/facilitySlice";
import Toast from "../components/Toast";

const ManageFacilities = () => {
  const dispatch = useDispatch();

  // Get download states from Redux
  const { isDownloadingCSV, downloadCSVError, successMessage } = useSelector(
    (state) => state.facility,
  );

  // Local toast state
  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "info",
  });
  const toastTimeoutRef = useRef(null);

  const showToast = (message, type = "info") => {
    if (toastTimeoutRef.current) {
      clearTimeout(toastTimeoutRef.current);
    }
    setToast({ show: true, message, type });
    toastTimeoutRef.current = setTimeout(() => {
      setToast({ show: false, message: "", type: "info" });
      toastTimeoutRef.current = null;
    }, 3000);
  };

  const hideToast = () => {
    if (toastTimeoutRef.current) {
      clearTimeout(toastTimeoutRef.current);
      toastTimeoutRef.current = null;
    }
    setToast({ show: false, message: "", type: "info" });
  };

  // Show Redux errors as toasts
  useEffect(() => {
    if (downloadCSVError) {
      showToast(downloadCSVError, "error");
      dispatch(clearFacilityState());
    }
  }, [downloadCSVError, dispatch]);

  useEffect(() => {
    if (successMessage) {
      showToast(successMessage, "success");
      dispatch(clearFacilityState());
    }
  }, [successMessage, dispatch]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (toastTimeoutRef.current) {
        clearTimeout(toastTimeoutRef.current);
      }
    };
  }, []);

  const handleDownloadCSV = () => {
    // Get the local time difference in hours (offset from UTC)
    const localTimeDifference = -new Date().getTimezoneOffset() / 60;
    dispatch(downloadFacilitiesCSV({ local_time_difference: localTimeDifference }));
  };

  return (
    <>
      {/* Toast Component */}
      {toast.show && (
        <Toast
          show={toast.show}
          message={toast.message}
          type={toast.type}
          onClose={hideToast}
          duration={3000}
        />
      )}

      <MasterLayout>
        <DefaultTopBar
          title="Facility Management"
          btnText2="Download CSV"
          btnLink2="#"
          isApiButton2={true}
          onBtn2Click={handleDownloadCSV}
          isBtn2Loading={isDownloadingCSV}
          btn2LoadingText="Downloading..."
        />

        <FacilityDataTable />
      </MasterLayout>
    </>
  );
};

export default ManageFacilities;
